import { USER_STRIPE_STATUS } from '../consts/user.consts';
import { QUERY_HOST_ID_VERIFICATION_STATUS } from '../graphql/user-queries';

/**
 * Whether an identity verification status leaves the host nothing more to do.
 * A verification that is still processing counts as complete, since the host
 * has already submitted everything Stripe asked for.
 *
 * @param {string} [status] - A USER_STRIPE_STATUS value, or undefined when unknown.
 * @returns {boolean} True when the host has nothing left to submit.
 */
export const isHostVerifyComplete = (status) => status === USER_STRIPE_STATUS.VERIFIED || status === USER_STRIPE_STATUS.PROCESSING;

/**
 * Reads the host's identity verification status, resolving to undefined instead
 * of rejecting when the lookup fails.
 *
 * The resolver behind this query calls out to Stripe, so it answers with a 500
 * whenever Stripe is unreachable or the stored verification session no longer
 * exists. None of that should stop the surrounding page from rendering, so
 * callers get an unknown status and carry on.
 *
 * @param {object} client - An ApolloClient instance.
 * @returns {Promise<string|undefined>} The status, or undefined when unknown.
 */
export const fetchHostVerifyStatus = async (client) => {
    try {
        const res = await client.query({ query: QUERY_HOST_ID_VERIFICATION_STATUS });

        return res?.data?.hostVerification?.status;
    } catch (error) {
        console.warn(error);

        return undefined;
    }
};
